import React from "react";
export const TermsOfService = () => {
  return <div className="py-20 bg-white" data-id="element-1449">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1450">
        <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1451">
          Terms of Service
        </h1>
        <div className="prose prose-lg max-w-none" data-id="element-1452">
          <p className="text-gray-600 mb-8" data-id="element-1453">Last updated: Feb 2025</p>
          <section className="mb-12" data-id="element-1454">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1455">
              1. Who We Are
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-1456">
              Ready Set Sell SRL ("we," "us," or "our") operates usegigi.ai.
              We're registered in Romania (CUI: RO47089455, Nr. Inreg:
              J40/21559/29.10.2022) with our headquarters at Intrarea Gheorghe
              Simionescu nr 19, Apt. B26, Sector 1, Bucuresti, Romania, 014155.
            </p>
            <p className="text-gray-600" data-id="element-1457">
              For legal matters, reach us at ready@set-sell.com
            </p>
          </section>
          <section className="mb-12" data-id="element-1458">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1459">
              2. The Basics
            </h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1460">
              <li data-id="element-1461">You must be at least 18 years old to use Gigi</li>
              <li data-id="element-1462">You need a valid email address to create an account</li>
              <li data-id="element-1463">One account per user (no sharing, sorry!)</li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1464">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1465">
              3. How Our Service Works
            </h2>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-1466">
              Free Trial & Credits
            </h3>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6" data-id="element-1467">
              <li data-id="element-1468">Start with 20 free credits per month</li>
              <li data-id="element-1469">Credits don't roll over to the next month</li>
              <li data-id="element-1470">One credit = one personalized outreach sequence</li>
              <li data-id="element-1471">Upgrade needed after free credits are used</li>
            </ul>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-1472">
              Subscriptions & Cancellations
            </h3>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1473">
              <li data-id="element-1474">Cancel your subscription anytime</li>
              <li data-id="element-1475">No refunds for unused credits</li>
              <li data-id="element-1476">Service continues until the end of your billing period</li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1477">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1478">
              4. Data & Privacy
            </h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1479">
              <li data-id="element-1480">
                We need LinkedIn access for automated campaigns (optional)
              </li>
              <li data-id="element-1481">Your data is stored securely and encrypted</li>
              <li data-id="element-1482">We use industry-standard security measures</li>
              <li data-id="element-1483">
                We work with trusted partners: OpenAI, Dux Soup, Smartlead, and
                Sendgrid
              </li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1484">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1485">
              5. Content & Intellectual Property
            </h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1486">
              <li data-id="element-1487">You own the content you create with Gigi</li>
              <li data-id="element-1488">We own our technology, algorithms, and platform</li>
              <li data-id="element-1489">
                AI-generated content is provided "as is" without warranties
              </li>
              <li data-id="element-1490">
                You're responsible for reviewing all AI-generated content before
                use
              </li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1491">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1492">
              6. Platform Guidelines
            </h2>
            <ul className="list-disc pl-6 text-gray-600 space-y-2" data-id="element-1493">
              <li data-id="element-1494">Follow LinkedIn's terms of service</li>
              <li data-id="element-1495">No spamming or harassment</li>
              <li data-id="element-1496">Respect rate limits and platform guidelines</li>
              <li data-id="element-1497">We may suspend accounts that violate these terms</li>
            </ul>
          </section>
          <section className="mb-12" data-id="element-1498">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1499">
              7. Changes & Updates
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-1500">
              We may update these terms as our service evolves. We'll notify you
              of significant changes via email. Continued use of Gigi after
              changes means you accept the new terms.
            </p>
          </section>
          <section className="mb-12" data-id="element-1501">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-1502">
              8. Dispute Resolution
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-1503">
              Any disputes will be resolved under Romanian law. We prefer to
              handle things amicably - reach out to us first if you have
              concerns.
            </p>
          </section>
          <div className="border-t border-gray-200 pt-8 mt-8" data-id="element-1504">
            <p className="text-gray-500 text-sm" data-id="element-1505">
              Questions about these terms? Contact us at ready@set-sell.com
            </p>
          </div>
        </div>
      </div>
    </div>;
};